"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueWithUnitConverter_1 = require("../../../core/conversions/ValueWithUnitConverter");

var ProductFlag_1 = require("../../../product/model/ProductFlag");

var ProductSizesDTO_1 = require("../../model/dto/ProductSizesDTO");

var ProductSizesDTOConverter_1 = require("./ProductSizesDTOConverter");
/**
 * Implementation of ProductSizesDTOConverter
 *
 * @author RV
 */


var ProductSizesDTOConverterImpl =
/*#__PURE__*/
function (_ProductSizesDTOConve) {
  _inherits(ProductSizesDTOConverterImpl, _ProductSizesDTOConve);

  function ProductSizesDTOConverterImpl() {
    _classCallCheck(this, ProductSizesDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSizesDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ProductSizesDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductSizesDTO_1.ProductSizesDTO(source.internalProductId, conversions.asFlagSet(source.flags, ProductFlag_1.ProductFlag), source.sizeCharger ? conversions.toBigNumber(source.sizeCharger) : null, source.sizeRatio ? conversions.toBigNumber(source.sizeRatio) : null, conversions.asObject(source, 'packageSize', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        internalProductId: source.internalProductId,
        flags: source.flags.serialize(),
        sizeCharger: source.sizeCharger ? conversions.fromBigNumber(source.sizeCharger) : null,
        sizeRatio: source.sizeRatio ? conversions.fromBigNumber(source.sizeRatio) : null,
        packageSize: conversions.asObject(source, 'packageSize', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions))
      });
      return result;
    }
  }]);

  return ProductSizesDTOConverterImpl;
}(ProductSizesDTOConverter_1.ProductSizesDTOConverter);

exports.ProductSizesDTOConverterImpl = ProductSizesDTOConverterImpl;